import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ReportFilters } from '../models/report-filters.model';
import { NgForm } from '@angular/forms';
import { ReportFilterCriteria } from '../models/report-filter-criteria.model';
import { CostCenterService } from '../services/cost-center.service';
import { FacilityService } from '../services/facility.service';
import { ShiftBlockService } from '../services/shift-block.service';
import * as moment from 'moment';
import { isNullOrUndefined } from 'util';
import { MiscUtil } from '../utilities/misc.util';
import { Facility } from '../models/facility.model';
import { ReportConstants } from 'src/app/smt/reports/shared/report-constants.util';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'report-filter',
  templateUrl: 'report-filter.component.html',
  styleUrls: ['report-filter.component.scss']
})

export class ReportFilterComponent implements OnInit 
{
    @Input() showCostCenters:boolean;
    @Input() showDateRange:boolean;
    @Input() showFacilities:boolean;
    @Input() showCensusTypes:boolean;
    @Input() showShiftBlocks:boolean;
    @Input() showPeriodEndDateSelection:boolean;
    @Input() showViews:boolean;
    @Input() defaultFilter:ReportFilters = new ReportFilters;
    @Input() views:string[];
    @Input() defaultView:string;
    @Input() defaultPayPeriodsBack:number;
    @Input() reportType:string;
    @Input() ancillaryType:string;
    @Input() showVarianceType:boolean;
    @Input() varianceTypes:string[];
    @Input() defaultVarianceType:string;
   
    @Output() filterUpdated = new EventEmitter();

    @ViewChild('facilityFilters') facilityFilter;
    @ViewChild('View') viewFilter;
    @ViewChild('CensusType') censusTypes;

    public facilityEditForm: NgForm;
    costCenters:ReportFilterCriteria[];
    facilities:ReportFilterCriteria[];
    shiftBlocks:ReportFilterCriteria[];
    visibleCostCenters:ReportFilterCriteria[];
    visibleShiftBlocks:ReportFilterCriteria[];
    visiblePeriodEnd:ReportFilterCriteria[];
    periodEndDates:ReportFilterCriteria[];
    facilityList: Facility[];
    
    private eventsSubscription: any; 
    reportFilter:ReportFilters;
    dateFrom:string;
    dateTo:string;
    defaultFrom:string;
    defaultTo:string;
    reportView: string;
    periodEnd:Date;
    censusType: string;
    showMidnightCensus:boolean = true;
    varianceType: string;
    showPeriodEnding:boolean;
    
    constructor(private _costCenterService:CostCenterService,
        private _facilityService:FacilityService,
        private _shiftBlockService:ShiftBlockService,
        private _route: ActivatedRoute
        ){}

    ngOnInit()
    {
        this.costCenters = [];
        this.facilities = [];
        this.shiftBlocks = [];
        this.periodEndDates = [];
        this.visiblePeriodEnd = [];
        this.facilityList = [];
        this.censusType =  ReportConstants.CensusType;
        this.getData().then(() => this.resetFilters());
        this.defaultFrom = moment(this.defaultFilter.dateFrom).format('YYYY-MM-DD');
        this.defaultTo = moment(this.defaultFilter.dateTo).format('YYYY-MM-DD');
        this.varianceType = this.defaultVarianceType;
    }

    applyFilters() {
      this.reportFilter.costCenterType = this.reportType;
      if (this.showDateRange) {
        this.reportFilter.dateFrom = moment(this.dateFrom).toDate();
        this.reportFilter.dateTo = moment(this.dateTo).toDate();
      }

      if (this.showCensusTypes) {
        this.reportFilter.censusTypes = [];
        this.reportFilter.censusTypes.push(this.censusType);
      }
        
        if (this.viewFilter && this.viewFilter.nativeElement.childNodes) {
          let childNodes = this.viewFilter.nativeElement.childNodes;
          for (let index = 0; index < childNodes.length; index++) {
            const element = childNodes[index];
            if (!isNullOrUndefined(element.firstChild as HTMLInputElement)) {
              let view: HTMLInputElement = element.firstChild;
              if (view.checked)
                  this.reportFilter.ReportView = view.value;
            }            
          }
        }

      if (this.showCostCenters) {
        let filteredCostCenters = this.visibleCostCenters.filter(c => c.checked == true);
        this.reportFilter.costCenterIds = (filteredCostCenters.length > 0 ? 
          filteredCostCenters.map((c) => c.id) : this.visibleCostCenters.map((c) => c.id));
      }

      if (this.showFacilities) {
        this.reportFilter.facilityIds = this.facilities.filter(f => f.checked == true).map((f) => f.id);
      }

      if (this.showShiftBlocks) {
        this.reportFilter.Shifts = this.visibleShiftBlocks.filter(s => s.checked == true).map((s) => s.value);
      }

      if (this.showPeriodEndDateSelection) {
        this.reportFilter.periodEndDates = this.visiblePeriodEnd.filter(p => p.checked).map((p) => p.value);
      }

      if (this.showVarianceType ) {
        this.reportFilter.varianceType = this.varianceType;          
      }

      this.updateReportFilter();
    }

    async getData()
    {
        
      if (this.showFacilities)
      {
          this.facilities = [];
          await this._facilityService.getFacilitiesInfiniteScroll(false,0,100,'','Name','ASC')
              .then((result) => {
                                  this.facilities = result.map((f) => <ReportFilterCriteria> {id:f.id,name:f.acronym,checked:false});
                                  this.facilityList = result;
                                  this.setPeriodEndDates()
                                });
      }

      if (this.showCostCenters)
      {       
        this.costCenters = [];
        this.shiftBlocks = [];
         if (!this.reportType)
         {
          this.reportType = "";
         }
        await this._costCenterService.GetDehydratedCostCenters(this.reportType, this.ancillaryType)
          .then((result) => 
          {
            if(result && result.length > 0)
            {
              this.costCenters = result.map((c) => <ReportFilterCriteria>
                {
                  id:c.id,
                  name:c.name,
                  checked:false,
                  parents:[c.facilityId]
                });                
              this.visibleCostCenters = this.costCenters;
              
              result.forEach(element => {
                let shifts : ReportFilterCriteria[] = element.shiftBlocks.map((s) => <ReportFilterCriteria>
                {
                  id: s.startHour,
                  name: MiscUtil.getShiftBlockDescription(s.startHour, s.endHour),
                  value: s,
                  checked: false,
                  parents:[element.id] // costcenterid
                });

                shifts.forEach((shift: ReportFilterCriteria) => {
                  let existing = this.shiftBlocks.findIndex(a => a.name == shift.name );

                  if ( existing >= 0)
                  {
                    this.shiftBlocks[existing].parents = shift.parents.concat(this.shiftBlocks[existing].parents);
                  }
                  else
                  {
                    this.shiftBlocks.push(shift)
                  }
                });
                
              });

              this.shiftBlocks = this.shiftBlocks.sort((a,b) => a.id - b.id);
              this.visibleShiftBlocks = this.shiftBlocks;

              this.facilities = this.facilities.filter(f => this.costCenters.some(c => c.parents.some(p => p == f.id)));
            }
          });
      }
    }

    resetFilters() {
      this.reportFilter = this.defaultFilter || new ReportFilters();
      let isSingleSelection = this.isSingleCostCenterSelection;

      if (this.showFacilities) {
        this.facilities.forEach(f => {
          f.checked = false;
          if(isSingleSelection){
            f.value = "";
          }
        });
      }
      if (this.showCensusTypes) {
        this.censusType = ReportConstants.CensusType;
      }
      if (this.showCostCenters) {
        this.visibleCostCenters = this.costCenters;
        this.visibleCostCenters.forEach(c => {
          c.checked = false;
          if(isSingleSelection){
            c.value = "";
          }
        });
      }

      if (this.showShiftBlocks) {
        this.visibleShiftBlocks = this.shiftBlocks;
        this.visibleShiftBlocks.forEach(f => f.checked = false);
      }

      if (this.showPeriodEndDateSelection) {
        this.visiblePeriodEnd = this.periodEndDates;
        this.periodEndDates.forEach(d => d.checked = false);
        this.resetPeriodEnd();
      }
    
      if (this.showViews) {
        this.reportFilter.ReportView = this.defaultView;

        let childNodes = this.viewFilter.nativeElement.childNodes;
        for (let index = 0; index < childNodes.length; index++) {
          const element = childNodes[index];
          if(!isNullOrUndefined(element.firstChild as HTMLInputElement))
          {
            let view:HTMLInputElement = element.firstChild;
            view.checked = view.value == this.defaultView;
          }
        }
      }
      
      if (this.showDateRange) {
          this.dateFrom = this.defaultFrom;
          this.dateTo = this.defaultTo;
      }
      if (this.showVarianceType) {
        this.varianceType = this.defaultVarianceType;
      }
      // default selection applied for all performance reports
      if(this.isSingleCostCenterSelection){
        this.facilityChanged(this.facilities[0]);
      }

      this.applyFilters();
    }

    setPeriodEndDates(){
        const periodLength = 14;
        const numberOfPayPeriods = 26;
        
        let facilities = this.facilityList; 
         while( facilities.length > 0) 
         {
           let curr = facilities.pop();
           let startDate = curr.payPeriodStartDate;
           let start = moment.utc(startDate).startOf("day");
           let today = moment.utc().startOf("day");
          
           //Build the list of facility Ids with the same start date then remove them from the queue
           let parents =  this.facilityList.filter(a => a.payPeriodStartDate == startDate).map(a => a.id);
           parents.push(curr.id);
           facilities = facilities.filter(a => a.payPeriodStartDate != startDate);
         
           let firstPeriodEnd = start.add(2, "weeks").subtract(1, "day");
           let offsetToPeriodEnd = today.diff(start, "days") % periodLength;          
           let periodEnd = today.add(periodLength - offsetToPeriodEnd, "days");
           let counterAdjust = 0;
           if(moment(start).format("M") == moment.utc().format("M") &&
              moment(start).format("Y") == moment.utc().format("Y")){
             counterAdjust = -1;
           }
           //Process the Period end dates based on start date
           for (let i = counterAdjust; i < numberOfPayPeriods && periodEnd >= firstPeriodEnd; i++) {
             let date = periodEnd.toDate();
             let existingDate = this.periodEndDates.filter(p => p.value.toString() == date.toString());
            
             if (existingDate.length) {
                 existingDate.forEach(e => e.parents = e.parents.concat(parents));
             } else {             
               if(this.isCurrentOrPastPayPeriod(periodEnd,periodLength)){
                   this.periodEndDates.push(<ReportFilterCriteria>{
                   checked:false,
                   name:periodEnd.format("MM/DD/YYYY"),
                   value:date,
                   parents:parents
                   });
               }
             }
            
             periodEnd.subtract(periodLength, "days");
           }          
         }
        
             //Sort the list in descending order
         this.periodEndDates = this.periodEndDates.sort((a,b) => b.value - a.value)
      }
    isCurrentOrPastPayPeriod(periodEnd,periodLength): boolean{
        let periodStart = moment(periodEnd).subtract(periodLength,"days").toDate();
        let currentPayPeriodDay = moment.utc().toDate(); 
        return moment(currentPayPeriodDay).isBetween(periodStart,periodEnd) || periodEnd < currentPayPeriodDay;
    }
    resetPeriodEnd()
    {
      this.visiblePeriodEnd.forEach(c => c.checked = false);

      if(this.defaultPayPeriodsBack > 0)
      {
        for(let i = 0 ; i < this.defaultPayPeriodsBack && i < this.visiblePeriodEnd.length ; i++ )
        {
          this.visiblePeriodEnd[i].checked = true;
        }
      }
    }

    updateReportFilter()
    {
        this.filterUpdated.emit(this.reportFilter);
    }

    costCentersChanged() {
        this.facilities.forEach(f => f.checked = this.visibleCostCenters.filter(c => c.checked).some(c => c.parents[0] == f.id));
        this.filterCostCenters();
        this.filterShiftBlocks();
        this.filterPeriodEndDates();
    }
        
    facilitiesChanged() {
        this.filterCostCenters();
        this.visibleCostCenters.forEach(c => c.checked = this.facilities.filter(f => f.checked).some(f => f.id == c.parents[0]));
        this.filterShiftBlocks();
        this.filterPeriodEndDates();
    }
    filterCostCenters()
    {
      let enabledFacilities = this.facilities.filter(f => f.checked);
      if (enabledFacilities.length > 0)
      {
        this.visibleCostCenters = this.costCenters.filter(c => enabledFacilities.some(f => c.parents.some(p => p == f.id) ));
      }
      else
      {
        this.visibleCostCenters = this.costCenters;
      }
    }
    filterShiftBlocks()
    {
      let enabledFacilities = this.facilities.filter(f => f.checked);
      if (enabledFacilities.length > 0)
      {
        this.visibleShiftBlocks = this.shiftBlocks.filter(s => this.visibleCostCenters.filter(c=>c.checked).some(f => s.parents.some(p => p == f.id) ));
      }
      else
      {
        this.visibleShiftBlocks = this.shiftBlocks;
      }
    }

    filterPeriodEndDates()
    {
      let enabledFacilities = this.facilities.filter(f => f.checked);
      
      if(enabledFacilities.length == 0)
      {
        this.visiblePeriodEnd = this.periodEndDates;
      }else 
      {
        this.visiblePeriodEnd = this.periodEndDates.filter(e => e.parents.some(p => enabledFacilities.some(f =>f.id == p )));        
      } 
      
      this.resetPeriodEnd();     
    }
    viewByChanged($event){
      let disableMidnightCensus = this.showCensusTypes && this.reportType =="inpatient" && $event.currentTarget.value == ReportConstants.ShiftBlockViewLabel;
      if(disableMidnightCensus){
        this.censusType = ReportConstants.CensusType;
      }
      this.showMidnightCensus = !disableMidnightCensus;
    }   
    
  costCenterChanged(costcenter: any) {

    this.facilities.forEach(c => {
      if (c.id == costcenter.parents[0]) {
        c.value = c.name;
        c.checked = true;
      }
      else{
        c.checked = false;
      }
    });
    this.filterCostCenterShiftBlocks(costcenter.id);
    this.filterPeriodEndDates();
  }
  facilityChanged(facility: any) {

    let defaultCostCenter;
    this.costCenters.forEach(c => {
      if (defaultCostCenter === undefined && this.facilities.filter(f => f.id == facility.id).some(f => f.id == c.parents[0])) {
        defaultCostCenter = c;
      }
    });
    this.facilities.forEach(f=>{
      if(f.id==facility.id){
        f.checked = true;
        f.value = f.name;
      }
      else{
        f.checked = false;
        f.value = "";
      }
    })

    if(defaultCostCenter)
    {
      this.filterCostCenterShiftBlocks(defaultCostCenter.id);
    }
    
    this.filterPeriodEndDates();
  }

  filterCostCenterShiftBlocks(costCenterId: number) {
    let facilityId = this.costCenters.filter(c=>c.id==costCenterId)[0].parents[0];
    this.visibleCostCenters = this.costCenters.filter(c => c.parents[0] == facilityId);
    this.visibleCostCenters.forEach(c=>{
      if(c.id==costCenterId){
        c.checked = true;
        c.value = c.name;
      }
      else{
        c.checked = false;
        c.value = "";
      }
    });
    this.visibleShiftBlocks = this.shiftBlocks.filter(s => this.visibleCostCenters.some(f => s.parents.some(p => p == f.id)));
  }
    
  get isSingleCostCenterSelection():boolean{
    let performanceReports = ['inpatient-performance-report','performance-report','total-uos-performance-report'];
    return performanceReports.some(n=> n === this._route.snapshot.routeConfig.path);
  }
}
